import './style.css';
import { Game } from './Game';

const container = document.getElementById('app');
if (!container) throw new Error('#app container not found');

const game = new Game(container);
game.start();
